import { useEffect, useCallback } from 'react';

export const useClickOutside = (
  ref: React.RefObject<HTMLElement>,
  handler: () => void,
  portalId?: string
) => {
  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (ref.current && !ref.current.contains(event.target as Node)) {
      // If portal is being used, also check if the click is within the portal
      if (portalId) {
        const portalContainer = document.getElementById(portalId);
        if (portalContainer && portalContainer.contains(event.target as Node)) {
          return; // Don't close if clicking inside portal
        }
      }
      handler();
    }
  }, [ref, handler, portalId]);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [handleClickOutside]);
};
